import { render, staticRenderFns } from "./bTestimonialsView.vue?vue&type=template&id=8c7e3b42&scoped=true"
import script from "./bTestimonialsView.vue?vue&type=script&lang=js"
export * from "./bTestimonialsView.vue?vue&type=script&lang=js"
import style0 from "./bTestimonialsView.vue?vue&type=style&index=0&id=8c7e3b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7e3b42",
  null
  
)

export default component.exports